export enum AuthUserGroup {
  ADMIN = "Admin",
  DOCTOR = "Doctor",
  HISTORIAN = "Historian",
  MEDICAL_ASSISTANT = "MedicalAssistant",
  UNAUTHORIZED = "Unauthorized",
}

export const isAdminUserGroup = (
  userGroup: AuthUserGroup | null | undefined,
): boolean => userGroup === AuthUserGroup.ADMIN;

export const isDoctorUserGroup = (
  userGroup: AuthUserGroup | null | undefined,
): boolean => userGroup === AuthUserGroup.DOCTOR;

export const isMedicalAssistantUserGroup = (
  userGroup: AuthUserGroup | null | undefined,
): boolean => userGroup === AuthUserGroup.MEDICAL_ASSISTANT;

export const isHistorianUserGroup = (
  userGroup: AuthUserGroup | null | undefined,
): boolean => userGroup === AuthUserGroup.HISTORIAN;
